import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  Button, TextField, Dialog, DialogTitle, DialogContent,
} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import { I18n } from 'react-redux-i18n';
import { getComponents } from '../../../redux/actions/tracker/componentsActions';
import globalStyles from '../../../styles';

const styles = theme => ({
  paper: {
    position: 'absolute',
    width: theme.spacing.unit * 100,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4,
  },
  div: {
    marginBottom: 20,
    marginRight: 100,

  },
});

class DialogDynamicsField extends React.Component {

  constructor(props) {

    super(props);

    this.state = {
      data: undefined,
      lstComponents: {},
      checked: [],
      Campos: [],
      anchorEl: null,
      inputValue: '',
      fieldsList: [],
    };
    this.renderListWithOptions = this.renderListWithOptions.bind(this);
    this.handleChange = this.handleChange.bind(this);

  }

  componentWillMount() {

    getComponents.then(lstComponents => this.setState({ lstComponents }));

  }

  componentWillReceiveProps(nextProps) {

    const nextPropsData = nextProps.data;
    const stateData = this.state.data;

    if (nextPropsData !== stateData) {

      this.setState({ data: nextPropsData });
      console.log('setState WillReceiveProps');

    }

  }

  handleChange = name => (event) => {

    const { data } = this.props;
    const currentIndex = data.fieldsList.map(obj => obj.name).indexOf(name);

    const field = {
      name,
      componentId: parseInt(event.target.value, 10),
    };

    if (currentIndex === -1) {

      data.fieldsList.push(field);
      this.setState({ data });

    } else {

      data.fieldsList[currentIndex].componentId = parseInt(event.target.value, 10);
      this.setState({ data });

    }
    console.log(data.fieldsList);

  };

  renderListWithOptions() {

    const { lstComponents, data } = this.state;
    const { classes } = this.props;
    let render = false;

    render = !!(data && data.fieldsList && data.fieldsList.length > 0);

    return (
      render && data.fieldsList.map(field => (
        <div>

          <Typography variant="subheading">{field.name}</Typography>

          <TextField
            id={data.name}
            select
            value={field.componentId}
            onChange={this.handleChange(field.name)}

            SelectProps={{
              autoWidth: true,
              native: true,
              MenuProps: {
                className: classes.menu,
              },
            }}
          >
            <option key={-1} value={-1} />
            {lstComponents.length > 0 && lstComponents.map(component => (
              <option key={component.componentId} value={component.componentId}>
                {component.description}
              </option>
            ))}
          </TextField>
          <Button aria-label="Delete" onClick={() => this.handleItemClickRemove(field)}>
            <DeleteIcon />
          </Button>

        </div>
      ))
    );


  }

  onChange = (e) => {

    this.setState({ inputValue: e.target.value });

  };

  handleItemClickRemove = (e) => {

    const dataRemove = this.props.data;

    const index = dataRemove.fieldsList.map(obj => obj.name).indexOf(e.name);
    if (index !== -1) dataRemove.fieldsList.splice(index, 1);

    this.setState({ data: dataRemove });

  }

  onExit = () => {

    console.log('onExit');

    this.setState({ Campos: [], data: [] });

  }

  onClick = () => {

    const { inputValue } = this.state;
    const { data } = this.props;
    const currentIndex = data.fieldsList.map(obj => obj.name).indexOf(inputValue);

    if (inputValue) {

      const field = {
        name: inputValue,
        componentId: -1,
      };

      if (currentIndex === -1) {

        data.fieldsList.push(field);
        this.setState({
          data,
          inputValue: '',
        });

      }

    }

  }

  render() {

    const { open, onClose, data } = this.props;
    const { inputValue } = this.state;

    return (
      <div>
        <Dialog
          open={open}
          onClose={onClose(data)}
          maxWidth="md"
          onExit={this.onExit}
        >
          <DialogTitle>
            {data && ` ${I18n.t('button.add_dynamic_fields')} - ${I18n.t('fields.phase')}: ${data.name}`}
          </DialogTitle>
          <DialogContent>
            <div style={{ maxWidth: 800, maxHeight: 800 }}>
              <TextField
                id="fieldName"
                label={I18n.t('fields.name')}
                value={inputValue}
                style={globalStyles.textField}
                onChange={this.onChange}
                autoComplete={false}
                onKeyPress={(event) => {

                  if (event.key === 'Enter') this.onClick();

                }}
              />

              <Button onClick={this.onClick} color="primary" variant="contained">
                {I18n.t('button.create')}
              </Button>
              {this.renderListWithOptions()}
            </div>
          </DialogContent>
        </Dialog>
      </div>
    );

  }
}

DialogDynamicsField.propTypes = {
  classes: PropTypes.object.classe,
};

export default withStyles(styles)(DialogDynamicsField);



// WEBPACK FOOTER //
// ./src/components/tracker/WorkFlow/DialogDynamicsField.js